export enum ContextFiltersEnum {
  ADD_ATTENDEES_MODAL_CONTEXT = "add_attendees_modal_context",
  LEARNING_PATH_ATTENDEES_MODAL_CONTEXT = "learning_path_attendees_modal_context",
  LEARNING_PATH_ADD_ATTENDEES_MODAL_CONTEXT = "learning_path_add_attendees_modal_context",
  LEARNING_PATH_TRAININGS_ATTENDEES_CONTEXT = "learning_path_trainings_attendees_context",
  WORKFLOW_HABILITATION_CONTEXT = "workflow_habilitation_context",
  USER_DETAIL_REQUESTS_CONTEXT = "user_detail_requests",
  USER_DETAIL_TRAININGS_CONTEXT = "user_detail_trainings",
}
